import { omit } from "lodash";
import React, { ReactElement } from "react";
import { Control, Controller, Path } from "react-hook-form";

export function EditableField<T>(
  props: Omit<
    React.ComponentProps<typeof Controller>,
    "control" | "render" | "name"
  > & {
    editing?: boolean;
    value?: any;
    control: Control<T>;
    name: Path<T>;
    children: ReactElement;
  }
) {
  const { editing = false, value, children } = props;
  const propsToPass = omit(
    props,
    "editing",
    "value",
    "elem",
    "onChange",
    "value"
  );

  return (
    <Controller
      {...propsToPass}
      defaultValue={value}
      render={({ field, fieldState: { error } }) =>
        React.cloneElement(children, {
          ...field,
          disabled: !editing,
          error: !!error,
          helperText: error ? error.message : undefined,
        })
      }
    />
  );
}
